export default {
  brewery: 'cycleBenefactorsClub',
  info_url: '',
  title: {
    in_progress: '',
    success: 'You Joined the Cycle Brewing Benefactors Club!',
    subtext: 'Join the Cycle Brewing Benefactors Club',
    sub_subtext: 'The first exclusive access club for the greatest enjoyers of barrel aged beers on the planet. ' +
      'The club runs every 3 months with shipments of the finest Doug From Cycle creations direct to your door! ' +
      'Each benefactor will receive 6 bottles of Barrel Aged Stout or Barleywine with a minimum of 3 different ' +
      'creations, but hopefully 6 unique bottles as membership allows!',
  },
  review: {
    summary: [
      'You are joining the Cycle Brewing Benefactors Club.',
      'By signing up, your card will be charged $249 per shipment (shipping included). ' +
      'You will receive four shipments per year, one every three months, timed to when the beers are ready. ' +
      'Each shipment contains six bottles of Barrel Aged Stout or Barleywine, with a minimum of three ' +
      'different creations and hopefully six unique bottles as membership allows.',
      'You will have the option to opt out by emailing support@tavour.com.',
      'You will receive a notification when your box has been charged and shipped.',
    ],
    button_text: 'Join the Club!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/cycleBenefactorsClub.js